import * as actionTypes from './actionTypes';

export const fetchLog = (
  PageFilterLogId,
  UserId,
  MyHistory,
  ShowLogs,
  ShowTags,
  Page,
  PageSize,
  SortBy,
  PageFilterCat,
  PageFilterTag,
  PageFilterUserId,
  PageFilterKeyword,
  PageFilterDateRange,
  PageFilterLocation,
  PageFilterFileType,
  PageFilterSeason,
  PageFilterRead,
  ViewType,
) => {
  return {
    type: actionTypes.FETCH_LOG,
    PageFilterLogId,
    UserId,
    MyHistory,
    ShowLogs,
    ShowTags,
    Page,
    PageSize,
    SortBy,
    PageFilterCat,
    PageFilterTag,
    PageFilterUserId,
    PageFilterKeyword,
    PageFilterDateRange,
    PageFilterLocation,
    PageFilterFileType,
    PageFilterSeason,
    PageFilterRead,
    ViewType,
  };
};

export const fetchLogStart = (Page, LogIds) => {
  return {
    type: actionTypes.FETCH_LOG_START,
    Page,
    LogIds,
  };
};

export const fetchLogSuccess = (LogIds, Posts, PostCount, Page, Categories, Users) => {
  return {
    type: actionTypes.FETCH_LOG_SUCCESS,
    LogIds,
    Posts,
    PostCount,
    Page,
    Categories,
    Users,
  };
};

export const fetchLogFailed = (error) => {
  return {
    type: actionTypes.FETCH_LOG_FAILED,
    error,
  };
};

export const clearAllLogs = () => {
  return {
    type: actionTypes.CLEAR_ALL_LOGS,
  };
};

export const fetchDrafts = (UserId, isManagedUser, SortBy, Page, PageSize, PageFilter) => {
  return {
    type: actionTypes.FETCH_DRAFTS,
    UserId,
    isManagedUser,
    SortBy,
    Page,
    PageSize,
    PageFilter,
  };
};

export const fetchDraftsStart = () => {
  return {
    type: actionTypes.FETCH_DRAFTS_START,
  };
};

export const fetchDraftsSuccess = (Drafts, Page, TotalDraftsCount) => {
  return {
    type: actionTypes.FETCH_DRAFTS_SUCCESS,
    Drafts,
    Page,
    TotalDraftsCount,
  };
};

export const fetchDraftsFailed = (error) => {
  return {
    type: actionTypes.FETCH_DRAFTS_FAILED,
    error,
  };
};

export const fetchMultiViewColumns = (
  ColumnType,
  ColumnNames,
  PageFilterLogId,
  UserId,
  MyHistory,
  ShowLogs,
  ShowTags,
  PageNum,
  PageSize,
  SortBy,
  PageFilterCat,
  PageFilterTag,
  PageFilterUserId,
  PageFilterKeyword,
  PageFilterDateRange,
  PageFilterLocation,
  PageFilterFileType,
  PageFilterSeason,
  PageFilterRead,
) => {
  return {
    type: actionTypes.FETCH_MULTI_VIEW_COLUMNS,
    ColumnType,
    ColumnNames,
    PageFilterLogId,
    UserId,
    MyHistory,
    ShowLogs,
    ShowTags,
    PageNum,
    PageSize,
    SortBy,
    PageFilterCat,
    PageFilterTag,
    PageFilterUserId,
    PageFilterKeyword,
    PageFilterDateRange,
    PageFilterLocation,
    PageFilterFileType,
    PageFilterSeason,
    PageFilterRead,
  };
};

export const fetchMultiViewColumnsStart = (ColumnType, ColumnNames, PageNum) => {
  return {
    type: actionTypes.FETCH_MULTI_VIEW_COLUMNS_START,
    ColumnType,
    ColumnNames,
    PageNum,
  };
};

export const fetchMultiViewColumnsSuccess = (ColumnType, ColumnNames, ColumnReturnObjects, PageNum, PageSize) => {
  return {
    type: actionTypes.FETCH_MULTI_VIEW_COLUMNS_SUCCESS,
    ColumnType,
    ColumnNames,
    ColumnReturnObjects,
    PageNum,
    PageSize,
  };
};

export const fetchMultiViewColumnsFailed = (error, ColumnType, ColumnNames) => {
  return {
    type: actionTypes.FETCH_MULTI_VIEW_COLUMNS_FAILED,
    error,
    ColumnType,
    ColumnName: ColumnNames,
  };
};

export const removeMultiViewColumns = (ColumnType, ColumnNames) => {
  return {
    type: actionTypes.REMOVE_MULTI_VIEW_COLUMNS,
    ColumnType,
    ColumnNames,
  };
};

export const fetchLogsDetails = (UserId, isManagedUser, LogId) => {
  return {
    type: actionTypes.FETCH_LOGS_DETAILS,
    UserId,
    isManagedUser,
    LogId,
  };
};

export const fetchLogsDetailsStart = () => {
  return {
    type: actionTypes.FETCH_LOGS_DETAILS_START,
  };
};

export const fetchLogsDetailsFailed = (error) => {
  return {
    type: actionTypes.FETCH_LOGS_DETAILS_FAILED,
    error,
  };
};

export const fetchLogsDetailsSuccess = (logsDetails) => {
  return {
    type: actionTypes.FETCH_LOGS_DETAILS_SUCCESS,
    logsDetails,
  };
};

// fetches list of members for each log that user is a member of
export const fetchMembersForLogs = () => {
  return {
    type: actionTypes.FETCH_MEMBERS_FOR_LOGS,
  };
};

export const fetchMembersForLogsStart = () => {
  return {
    type: actionTypes.FETCH_MEMBERS_FOR_LOGS_START,
  };
};

export const fetchMembersForLogsSuccess = (logs) => {
  return {
    type: actionTypes.FETCH_MEMBERS_FOR_LOGS_SUCCESS,
    logs,
  };
};

export const fetchMembersForLogsFailed = (error) => {
  return {
    type: actionTypes.FETCH_MEMBERS_FOR_LOGS_FAILED,
    error,
  };
};

export const fetchTagsForLogs = (LogId) => {
  return {
    type: actionTypes.FETCH_TAGS_FOR_LOGS,
    LogId,
  };
};

export const fetchTagsStart = () => {
  return {
    type: actionTypes.FETCH_TAGS_START,
  };
};

export const fetchTagsSuccess = (logs) => {
  return {
    type: actionTypes.FETCH_TAGS_SUCCESS,
    logs,
  };
};

export const fetchTagsFailed = (error) => {
  return {
    type: actionTypes.FETCH_TAGS_FAILED,
    error,
  };
};

export const createLog = (Name, Visibility, UserId, isManagedUser) => {
  return {
    type: actionTypes.CREATE_LOG,
    Name,
    Visibility,
    UserId,
    isManagedUser,
  };
};

export const createLogStart = () => {
  return {
    type: actionTypes.CREATE_LOG_START,
  };
};

export const createLogSuccess = () => {
  return {
    type: actionTypes.CREATE_LOG_SUCCESS,
  };
};

export const createLogFailed = (error) => {
  return {
    type: actionTypes.CREATE_LOG_FAILED,
    error,
  };
};

export const logAddRemoveMembers = (LogId, InviteUsersIds, InviteUsersEmails, RemoveUsersIds, InviteMessage, isManagedUser, UserId, KeepPosts) => {
  return {
    type: actionTypes.LOG_ADD_REMOVE_MEMBERS,
    LogId,
    InviteUsersIds,
    InviteUsersEmails,
    InviteMessage,
    RemoveUsersIds,
    isManagedUser,
    UserId,
    KeepPosts,
  };
};

export const logAddRemoveMembersStart = () => {
  return {
    type: actionTypes.LOG_ADD_REMOVE_MEMBERS_START,
  };
};

export const logAddRemoveMembersSuccess = (UsersInvited, UsersRemoved) => {
  return {
    type: actionTypes.LOG_ADD_REMOVE_MEMBERS_SUCCESS,
    UsersInvited,
    UsersRemoved,
  };
};

export const logAddRemoveMembersFailed = () => {
  return {
    type: actionTypes.LOG_ADD_REMOVE_MEMBERS_FAILED,
  };
};

export const logRemoveArchivedUsers = (LogId, RemoveUserIds, isManagedUser, UserId) => {
  return {
    type: actionTypes.LOG_REMOVE_ARCHIVED_USERS,
    LogId,
    RemoveUserIds,
    isManagedUser,
    UserId,
  };
};

export const logRemoveArchivedUsersStart = () => {
  return {
    type: actionTypes.LOG_REMOVE_ARCHIVED_USERS_START,
  };
};

export const logRemoveArchivedUsersSuccess = (Removed, LogId) => {
  return {
    type: actionTypes.LOG_REMOVE_ARCHIVED_USERS_SUCCESS,
    Removed,
    LogId,
  };
};

export const logRemoveArchivedUsersFailed = () => {
  return {
    type: actionTypes.LOG_REMOVE_ARCHIVED_USERS_FAILED,
  };
};

export const logInviteNewUsers = (LogId, Name, Email, MobileNumber, InviteMessage, isManagedUser, UserId) => {
  return {
    type: actionTypes.LOG_INVITE_NEW_USERS,
    LogId,
    Name,
    Email,
    MobileNumber,
    InviteMessage,
    isManagedUser,
    UserId,
  };
};

export const logInviteNewUsersStart = () => {
  return {
    type: actionTypes.LOG_INVITE_NEW_USERS_START,
  };
};

export const logInviteNewUsersSuccess = (invitee) => {
  return {
    type: actionTypes.LOG_INVITE_NEW_USERS_SUCCESS,
    invitee,
  };
};

export const logInviteNewUsersFailed = (error) => {
  return {
    type: actionTypes.LOG_INVITE_NEW_USERS_FAILED,
    error,
  };
};

export const logUpdateUserAccess = (LogId, ForUserId, Access, UserId, isManagedUser) => {
  return {
    type: actionTypes.LOG_UPDATE_USER_ACCESS,
    LogId,
    ForUserId,
    Access,
    UserId,
    isManagedUser,
  };
};

export const logUpdateUserAccessStart = () => {
  return {
    type: actionTypes.LOG_UPDATE_USER_ACCESS_START,
  };
};

export const logUpdateUserAccessSuccess = () => {
  return {
    type: actionTypes.LOG_UPDATE_USER_ACCESS_SUCCESS,
  };
};

export const logUpdateUserAccessFailed = (error) => {
  return {
    type: actionTypes.LOG_UPDATE_USER_ACCESS_FAILED,
    error,
  };
};

export const logTransferHost = (LogId, ToUserId, UserId, isManagedUser) => {
  return {
    type: actionTypes.LOG_TRANSFER_HOST,
    LogId,
    ToUserId,
    UserId,
    isManagedUser,
  };
};

export const logTransferHostStart = () => {
  return {
    type: actionTypes.LOG_TRANSFER_HOST_START,
  };
};

export const logTransferHostSuccess = () => {
  return {
    type: actionTypes.LOG_TRANSFER_HOST_SUCCESS,
  };
};

export const logTransferHostFailed = () => {
  return {
    type: actionTypes.LOG_TRANSFER_HOST_FAILED,
  };
};

// This endpoint is only called when the postingAs user is removing themself
// from a log they're a member of
export const logLeave = (logId, RemoveUsersIds, isManagedUser, UserId, isSelf) => {
  return {
    type: actionTypes.LOG_LEAVE,
    logId,
    RemoveUsersIds,
    isManagedUser,
    UserId,
    isSelf,
  };
};

export const logLeaveStart = () => {
  return {
    type: actionTypes.LOG_LEAVE_START,
  };
};

export const logLeaveSuccess = (numberOfUsersRemoved) => {
  return {
    type: actionTypes.LOG_LEAVE_SUCCESS,
    numberOfUsersRemoved,
  };
};

export const logLeaveFailed = (error) => {
  return {
    type: actionTypes.LOG_LEAVE_FAILED,
    error,
  };
};

export const logUpdate = (LogId, Name, Delete, postingAsUserId, isManagedUser) => {
  return {
    type: actionTypes.LOG_UPDATE,
    LogId,
    Name,
    Delete,
    postingAsUserId,
    isManagedUser,
  };
};

export const logUpdateStart = () => {
  return {
    type: actionTypes.LOG_UPDATE_START,
  };
};

export const logUpdateSuccess = (logId, Deleted, Name) => {
  return {
    type: actionTypes.LOG_UPDATE_SUCCESS,
    logId,
    Deleted,
    Name,
  };
};

export const logUpdateFailed = (error) => {
  return {
    type: actionTypes.LOG_UPDATE_FAILED,
    error,
  };
};

export const toggleGiftsDraftsModal = () => {
  return {
    type: actionTypes.TOGGLE_GIFTS_DRAFTS_MODAL,
  };
};
